<template>
  <div>
    <HttpContentView :endpoint="utilities.path('modules/applications/categories/@', categoryId)" v-model:reload="reloadCategory">
      <template v-slot:content="{ data: category }">
        <div v-if="category && canChangeStatus" class="card mb-4">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h3 class="d-flex align-items-center g-3">
                <i :class="category.open ? 'fas fa-lock-open text-success' : 'fas fa-lock text-warning'"></i>
                <span>{{ category.open ? translate('open') : translate('closed') }}</span>
              </h3>
              <HttpFormView :endpoint="utilities.path('modules/applications/categories/@/@', categoryId, category.open ? 'close' : 'open')" method="post" @success="reloadCategory = true">
                <template v-slot:form="{ submit, loading }">
                  <ButtonView type="normal" color="primary" @click="submit">
                    <div class="d-flex align-items-center g-2">
                      <i :class="category.open ? 'fas fa-lock' : 'fas fa-lock-open'"></i>
                      <span>{{ category.open ? translate("close") : translate("open") }}</span>
                    </div>
                  </ButtonView>
                  <SpinnerView :active="loading" color="primary"/>
                </template>
              </HttpFormView>
            </div>
            <div v-if="category.open">
              {{ translate("applications.open.description") }}
            </div>
            <div v-else>
              {{ translate("applications.closed.description") }}
            </div>
          </div>
        </div>
        <CollectionView :endpoint="utilities.path('modules/applications/categories/@/applications', categoryId)" v-model:reload="reload">
          <template v-slot:header>
            <h4 class="mb-0">{{ translate("applications") }}</h4>
          </template>
          <template v-slot:content="{ items }">
            <div class="card">
              <div class="table-responsive">
                <div class="table">
                  <div class="table-header">
                    <div class="table-header-cell">{{ translate("creator") }}</div>
                    <div class="table-header-cell">{{ translate("status") }}</div>
                    <div class="table-header-cell">{{ translate("created_at") }}</div>
                    <div class="table-header-cell">{{ translate("replied_at") }}</div>
                    <div class="table-header-cell">{{ translate("actions") }}</div>
                  </div>
                  <div class="table-body">
                    <div class="table-row" v-for="item in items" :key="item.id">
                      <div class="table-column">
                        <PlayerView v-if="item.creator" :player="item.creator"/>
                      </div>
                      <div class="table-column" :class="{ 'text-danger': item.status.id === 3, 'text-success': item.status.id === 2, 'text-info': item.status.id === 1 }">{{ item.status.name }}</div>
                      <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                      <div class="table-column">{{ item.repliedAt ? utilities.formatDatetime(item.repliedAt) : "" }}</div>
                      <div class="table-column">
                        <div class="d-flex align-items-center g-2">
                          <TargetedModalView size="large">
                            <template v-slot:target="{ show }">
                              <ButtonView type="soft" color="primary" size="small" @click="show">
                                <i class="fas fa-eye"></i>
                              </ButtonView>
                            </template>
                            <template v-slot:header="{ hide }">
                              <div class="d-flex align-items-center justify-content-between g-4">
                                <h3 class="mb-0">{{ translate("application") }}</h3>
                                <ModalCloseButtonView @click="hide"/>
                              </div>
                            </template>
                            <template v-slot:body="{ hide }">
                              <ApplicationView :application-id="item.id" @reply="hide(); reload = true" @delete="hide(); reload = true"/>
                            </template>
                          </TargetedModalView>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </CollectionView>
      </template>
    </HttpContentView>
  </div>
</template>

<script setup>
import {
  CollectionView,
  HttpFormView,
  HttpContentView,
  utilities,
  ButtonView,
  TargetedModalView,
  SpinnerView, ModalCloseButtonView
} from "@niftybit/vue";
import ApplicationView from "@/systems/modules/applications/ApplicationView.vue";
import PlayerView from "@/components/other/PlayerView.vue";
import {computed, onMounted, onUnmounted, ref} from "vue";
import authorization from "@/authorization";
import {state} from "@/state";

const props = defineProps({
  communityId: String,
  categoryId: String
});

const reload = ref(false);
const reloadCategory = ref(false);

const canChangeStatus = computed(() => authorization.permission("modules.applications.categories.edit") || authorization.resourcePermission("modules.applications.category", props.categoryId, "status.change"));

function onRouteReload() {
  reload.value = true;
}

onMounted(() => {
  state.plugins.reloadRoute.listeners.push(onRouteReload);
});

onUnmounted(() => {
  state.plugins.reloadRoute.listeners = state.plugins.reloadRoute.listeners.filter(item => item !== onRouteReload);
});
</script>